<template>
  <div class="mr-6">
    <v-btn
      id="messages-launcher"
      class="uwill-primary-button outline"
      :aria-expanded="inbox.state.isOpen ? 'true' : 'false'"
      @click="inbox.open()"
    >
      <v-icon class="mr-2">fa-regular fa-message</v-icon>
      Messages
      <v-badge
        v-if="inbox.state.unreadTotal > 0"
        class="ml-2"
        color="error"
        :content="inbox.state.unreadTotal"
        inline
      ></v-badge>
    </v-btn>
  </div>
</template>
<script>
import useInboxState from "@/composables/useInboxState";

const inbox = useInboxState();

export default {
  name: "InboxLauncher",
  data() {
    return { inbox };
  },
  mounted() {
    inbox.loadUnreadTotal();
    // Messaging::UnreadCount is Redis-cached (~90s TTL) server-side, so
    // polling this doesn't mean a Postgres hit on every tick.
    this.pollTimer = setInterval(inbox.loadUnreadTotal, 60000);
  },
  beforeUnmount() {
    clearInterval(this.pollTimer);
  }
};
</script>

<style lang="scss" scoped></style>
